<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>
<div class="page-title">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <h1 class="h2" style="color:#000;font-weight:600;">Apply Online</h1>
                <p class="add-pro-adver-p2"><strong>Note:</strong> $50 application fee  <a href="/assets/pdf/Application NBP.pdf" target="_blank" style="color:#802020;">Click here</a> to
                    download application form.</p>
            </div>
        </div>
    </div>
</div>
<section class="">
    <div class="container">
        <ul class="apply-online-step clearfix">
            <li class="{{step===1?'active':''}}">
                <div class="number-text">
                    <p>1</p>
                </div>
            </li>
            <hr>
            <li class="{{step===2?'active':''}}">
                <div class="number-text">
                    <p>2</p>
                </div>
            </li>
            <hr>
            <li class="{{step===3?'active':''}}">
                <div class="number-text">
                    <p>3</p>
                </div>
            </li>
            <hr>
            <li class="{{step===4?'active':''}}">
                <div class="number-text">
                    <p>4</p>
                </div>
            </li>
        </ul>
        <form class="apply-online" [formGroup]="onlineApplicationForm1" (ngSubmit)="onlineApplication1()">
            <fieldset *ngIf="step===1">
                <div class="row">
                    <div class="col-12">
                        <!-- <div class="form-group">
                            <input type="text" class="form-control" placeholder="Your Full Name" formControlName="full_name" />
                            <ngb-alert [dismissible]="false" [type]="'danger'"
                                *ngIf="emailFriendForm.get('full_name')?.dirty && emailFriendForm.get('full_name')?.invalid" class="text-left">
                                <div *ngIf="emailFriendForm.get('full_name')?.errors?.required">Your full name is required.</div>
                            </ngb-alert>
                        </div> -->
                        <div class="form-group">
                            <label style="display: block;">Are you a current tenant or have you leased with us
                                before?<span style="color: red;"> *</span></label>
                            <input type="radio" id="yes" name="current_tenant" formControlName="current_tenant"
                                class="form-control simple" value=1>
                            <label for="yes">Yes</label>
                            <input type="radio" id="no" name="current_tenant" formControlName="current_tenant"
                                class="form-control simple" value=0>
                            <label for="no" style="margin-left: 10px;">No</label>
                            <ngb-alert [dismissible]="false" [type]="'danger'"
                                *ngIf="onlineApplicationForm1.get('current_tenant')?.dirty && onlineApplicationForm1.get('current_tenant')?.invalid"
                                class="text-left">
                                <div *ngIf="onlineApplicationForm1.get('current_tenant')?.errors?.required">Current
                                    tenant is
                                    required.
                                </div>
                            </ngb-alert>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <h2 class="h4 mb-3 theme-cl">About The Property You Are Applying For</h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                            <label for="pro_address1">Address1<span style="color: red;"> *</span></label>
                            <input type="text" class="form-control simple" formControlName="pro_address1"
                                [readonly]="readonly">
                            <ngb-alert [dismissible]="false" [type]="'danger'"
                                *ngIf="onlineApplicationForm1.get('pro_address1')?.dirty && onlineApplicationForm1.get('pro_address1')?.invalid"
                                class="text-left">
                                <div *ngIf="onlineApplicationForm1.get('pro_address1')?.errors?.required">Address1 is
                                    required.
                                </div>
                            </ngb-alert>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                            <label>Address2</label>
                            <input type="text" class="form-control simple" formControlName="pro_address2">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                            <label>Agent ( If you are working with one - otherwise put "NONE" )</label>
                            <input type="text" class="form-control simple" formControlName="agent_name">
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                            <label>Agent Phone</label>
                            <input type="tel" class="form-control simple" formControlName="agent_phone">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                            <label>Agent Email</label>
                            <input type="email" class="form-control simple" formControlName="agent_email">
                            <ngb-alert [dismissible]="false" [type]="'danger'"
                                *ngIf="onlineApplicationForm1.get('agent_email')?.dirty && onlineApplicationForm1.get('agent_email')?.invalid"
                                class="text-left">
                                <div *ngIf="onlineApplicationForm1.get('agent_email')?.errors?.pattern">Email is
                                    invalid.
                                </div>
                            </ngb-alert>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-12">
                        <h2 class="h4 mb-3 theme-cl">About You</h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-3">
                        <div class="form-group">
                            <label>First Name<span style="color: red;"> *</span></label>
                            <input type="text" class="form-control simple" formControlName="name">
                            <ngb-alert [dismissible]="false" [type]="'danger'"
                                *ngIf="onlineApplicationForm1.get('name')?.dirty && onlineApplicationForm1.get('name')?.invalid"
                                class="text-left">
                                <div *ngIf="onlineApplicationForm1.get('name')?.errors?.required">First Name is
                                    required.
                                </div>
                            </ngb-alert>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3">
                        <div class="form-group">
                            <label>Last Name<span style="color: red;"> *</span></label>
                            <input type="text" class="form-control simple" formControlName="surname">
                            <ngb-alert [dismissible]="false" [type]="'danger'"
                                *ngIf="onlineApplicationForm1.get('surname')?.dirty && onlineApplicationForm1.get('surname')?.invalid"
                                class="text-left">
                                <div *ngIf="onlineApplicationForm1.get('surname')?.errors?.required">Last Name is
                                    required.
                                </div>
                            </ngb-alert>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="form-group">
                            <label>Email<span style="color: red;"> *</span></label>
                            <input type="eamil" class="form-control simple" formControlName="username">
                            <ngb-alert [dismissible]="false" [type]="'danger'"
                                *ngIf="onlineApplicationForm1.get('username')?.dirty && onlineApplicationForm1.get('username')?.invalid"
                                class="text-left">
                                <div *ngIf="onlineApplicationForm1.get('username')?.errors?.pattern">Email is invalid.
                                </div>
                                <div *ngIf="onlineApplicationForm1.get('username')?.errors?.required">Email is required.
                                </div>
                            </ngb-alert>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-3">
                        <div class="form-group">
                            <label>Work Phone<span style="color: red;"> *</span></label>
                            <input type="tel" class="form-control simple" mask="0*" maxlength="12"
                                formControlName="work_phone">
                            <ngb-alert [dismissible]="false" [type]="'danger'"
                                *ngIf="onlineApplicationForm1.get('work_phone')?.dirty && onlineApplicationForm1.get('work_phone')?.invalid"
                                class="text-left">
                                <div *ngIf="onlineApplicationForm1.get('work_phone')?.errors?.required">Work Phone is
                                    required.
                                </div>
                                <div *ngIf="onlineApplicationForm1.get('work_phone')?.errors?.mask">Work Phone is
                                    invalid.
                                </div>
                            </ngb-alert>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3">
                        <div class="form-group">
                            <label>Home Phone<span style="color: red;"> *</span></label>
                            <input type="tel" class="form-control simple" mask="0*" maxlength="12"
                                formControlName="home_phone">
                            <ngb-alert [dismissible]="false" [type]="'danger'"
                                *ngIf="onlineApplicationForm1.get('home_phone')?.dirty && onlineApplicationForm1.get('home_phone')?.invalid"
                                class="text-left">
                                <div *ngIf="onlineApplicationForm1.get('home_phone')?.errors?.required">Home Phone is
                                    required.
                                </div>
                                <div *ngIf="onlineApplicationForm1.get('home_phone')?.errors?.mask">Home Phone is
                                    invalid.
                                </div>
                            </ngb-alert>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3">
                        <div class="form-group">
                            <label>Cell Phone</label>
                            <input type="tel" class="form-control simple" formControlName="cell_phone">
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3">
                        <div class="form-group">
                            <label>Occupation</label>
                            <input type="text" class="form-control simple" formControlName="occupation">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-3">
                        <div class="form-group">
                            <label>Company Name</label>
                            <input type="text" class="form-control simple" formControlName="company_name">
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3">
                        <div class="form-group">
                            <label>Length of Employment</label>
                            <input type="number" class="form-control simple" formControlName="length_of_employment">
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3">
                        <div class="form-group">
                            <label>Monthly net Income</label>
                            <input type="text" class="form-control simple" formControlName="monthly_net_income">
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3">
                        <div class="form-group">
                            <label>Other Monthly Income</label>
                            <input type="text" class="form-control simple" formControlName="other_monthly_income">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <div class="form-group">
                            <label>Social Security Number<span style="color: red;"> *</span></label>
                            <input type="text" class="form-control simple" mask="000-00-0*" maxlength="14"
                                formControlName="social_security_number">
                            <ngb-alert [dismissible]="false" [type]="'danger'"
                                *ngIf="onlineApplicationForm1.get('social_security_number')?.dirty && onlineApplicationForm1.get('social_security_number')?.invalid"
                                class="text-left">
                                <div *ngIf="onlineApplicationForm1.get('social_security_number')?.errors?.required">
                                    Social Security Number is required.
                                </div>
                                <div *ngIf="onlineApplicationForm1.get('social_security_number')?.errors?.mask">Social
                                    Security Number is invalid.
                                </div>
                            </ngb-alert>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <div class="form-group">
                            <label>Drivers License Number<span style="color: red;"> *</span></label>
                            <input type="text" maxlength="16" class="form-control simple"
                                formControlName="drivers_license_number">
                            <ngb-alert [dismissible]="false" [type]="'danger'"
                                *ngIf="onlineApplicationForm1.get('drivers_license_number')?.dirty && onlineApplicationForm1.get('drivers_license_number')?.invalid"
                                class="text-left">
                                <div *ngIf="onlineApplicationForm1.get('drivers_license_number')?.errors?.required">
                                    Drivers License Number is required.
                                </div>
                                <!-- <div *ngIf="onlineApplicationForm1.get('drivers_license_number')?.errors?.mask">Drivers
                                    License Number is invalid.
                                </div> -->
                            </ngb-alert>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <div class="form-group">
                            <label>Birth Date<span style="color: red;"> *</span></label>
                            <input type="text" placeholder="mm/dd/yyyy" class="form-control simple" mask="M0/d0/0000"
                                [leadZeroDateTime]="true" formControlName="birth_date">
                            <ngb-alert [dismissible]="false" [type]="'danger'"
                                *ngIf="onlineApplicationForm1.get('birth_date')?.dirty && onlineApplicationForm1.get('birth_date')?.invalid"
                                class="text-left">
                                <div *ngIf="onlineApplicationForm1.get('birth_date')?.errors?.required">Birth Date is
                                    required.
                                </div>
                                <div *ngIf="onlineApplicationForm1.get('birth_date')?.errors?.mask">
                                    Birth date is invalid.
                                </div>
                            </ngb-alert>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <div class="form-group">
                            <label>Savings Account Bank</label>
                            <input type="text" class="form-control simple" formControlName="savings_account_bank">
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <div class="form-group">
                            <label>Branch</label>
                            <input type="text" class="form-control simple" formControlName="saving_branch">
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <div class="form-group">
                            <label>Account Number</label>
                            <input type="text" class="form-control simple" formControlName="saving_account_number">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <div class="form-group">
                            <label>Checking Account Bank</label>
                            <input type="text" class="form-control simple" formControlName="checking_account_bank">
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <div class="form-group">
                            <label>Branch</label>
                            <input type="text" class="form-control simple" formControlName="checking_branch">
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <div class="form-group">
                            <label>Account Number</label>
                            <input type="text" class="form-control simple" formControlName="checking_account_number">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                            <label>Current Address1<span style="color: red;"> *</span></label>
                            <input type="text" class="form-control simple" formControlName="current_address1">
                            <ngb-alert [dismissible]="false" [type]="'danger'"
                                *ngIf="onlineApplicationForm1.get('current_address1')?.dirty && onlineApplicationForm1.get('current_address1')?.invalid"
                                class="text-left">
                                <div *ngIf="onlineApplicationForm1.get('current_address1')?.errors?.required">Current
                                    Address1 is required.
                                </div>
                            </ngb-alert>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                            <label>Current Address2</label>
                            <input type="text" class="form-control simple" formControlName="current_address2">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-3">
                        <div class="form-group">
                            <label>City<span style="color: red;"> *</span></label>
                            <input type="text" class="form-control simple" formControlName="city">
                            <ngb-alert [dismissible]="false" [type]="'danger'"
                                *ngIf="onlineApplicationForm1.get('city')?.dirty && onlineApplicationForm1.get('city')?.invalid"
                                class="text-left">
                                <div *ngIf="onlineApplicationForm1.get('city')?.errors?.required">City is required.
                                </div>
                            </ngb-alert>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3">
                        <div class="form-group">
                            <label>State<span style="color: red;"> *</span></label>
                            <input type="text" class="form-control simple" formControlName="state">
                            <ngb-alert [dismissible]="false" [type]="'danger'"
                                *ngIf="onlineApplicationForm1.get('state')?.dirty && onlineApplicationForm1.get('state')?.invalid"
                                class="text-left">
                                <div *ngIf="onlineApplicationForm1.get('state')?.errors?.required">State is required.
                                </div>
                            </ngb-alert>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3">
                        <div class="form-group">
                            <label>Zip Code<span style="color: red;"> *</span></label>
                            <input type="text" class="form-control simple" mask="0*" maxlength="8"
                                formControlName="zipcode">
                            <ngb-alert [dismissible]="false" [type]="'danger'"
                                *ngIf="onlineApplicationForm1.get('zipcode')?.dirty && onlineApplicationForm1.get('zipcode')?.invalid"
                                class="text-left">
                                <div *ngIf="onlineApplicationForm1.get('zipcode')?.errors?.required">Zip Code is
                                    required.
                                </div>
                                <div *ngIf="onlineApplicationForm1.get('zipcode')?.errors?.mask">Zip Code is invalid.
                                </div>
                            </ngb-alert>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3">
                        <div class="form-group">
                            <label>Country</label>
                            <input type="text" class="form-control simple" formControlName="country">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="form-group">
                            <label>How Long at This Address</label>
                            <input type="text" class="form-control simple" formControlName="howlong_at_this_address">
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3">
                        <div class="form-group">
                            <label>Rent</label>
                            <input type="text" class="form-control simple" formControlName="rent">
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3">
                        <div class="form-group">
                            <label>Reason For Moving</label>
                            <input type="text" class="form-control simple" formControlName="reason_for_moving">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="form-group">
                            <label>Owner / Landlord<span style="color: red;"> *</span></label>
                            <input type="text" class="form-control simple" formControlName="owner">
                            <ngb-alert [dismissible]="false" [type]="'danger'"
                                *ngIf="onlineApplicationForm1.get('owner')?.dirty && onlineApplicationForm1.get('owner')?.invalid"
                                class="text-left">
                                <div *ngIf="onlineApplicationForm1.get('owner')?.errors?.required">Owner / Landlord is
                                    required.
                                </div>
                            </ngb-alert>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="form-group">
                            <label>Phone<span style="color: red;"> *</span></label>
                            <input type="tel" class="form-control simple" mask="000000000*" maxlength="13" formControlName="phone">
                            <ngb-alert [dismissible]="false" [type]="'danger'"
                                *ngIf="onlineApplicationForm1.get('phone')?.dirty && onlineApplicationForm1.get('phone')?.invalid"
                                class="text-left">
                                <div *ngIf="onlineApplicationForm1.get('phone')?.errors?.required">Phone is required.
                                </div>
                                <div *ngIf="onlineApplicationForm1.get('phone')?.errors?.mask">Phone is invalid.
                                </div>
                            </ngb-alert>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-2 col-md-2 col-sm-6 pr-sm-0">
                        <div class="form-group">
                            <label>Emergency Contact Name<span style="color: red;"> *</span></label>
                            <input type="text" class="form-control simple" formControlName="emergency_contact_name">
                            <ngb-alert [dismissible]="false" [type]="'danger'"
                                *ngIf="onlineApplicationForm1.get('emergency_contact_name')?.dirty && onlineApplicationForm1.get('emergency_contact_name')?.invalid"
                                class="text-left">
                                <div *ngIf="onlineApplicationForm1.get('emergency_contact_name')?.errors?.required">Emergency Contact Name is required.
                                </div>
                            </ngb-alert>
                        </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-6 pr-sm-0">
                        <div class="form-group">
                            <label>Emergency Contact Phone<span style="color: red;"> *</span></label>
                            <input type="tel" class="form-control simple" mask="0*" maxlength="13" formControlName="emergency_contact_phone">
                            <ngb-alert [dismissible]="false" [type]="'danger'"
                                *ngIf="onlineApplicationForm1.get('emergency_contact_phone')?.dirty && onlineApplicationForm1.get('emergency_contact_phone')?.invalid"
                                class="text-left">
                                <div *ngIf="onlineApplicationForm1.get('emergency_contact_phone')?.errors?.required">Emergency Contact Phone is required.
                                </div>
                            </ngb-alert>
                        </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-6">
                        <div class="form-group">
                            <p>Do You Have Any Pets<span style="color: red;"> *</span></p>
                            <ul class="no-ul-list">
                                <li>
                                    <input id="is_pet_yes" class="checkbox-custom" name="is_pet" type="radio"
                                        formControlName="is_pet" value=1>
                                    <label for="is_pet_yes" class="checkbox-custom-label">Yes</label>
                                </li>
                                <li>
                                    <input id="is_pet_no" class="checkbox-custom" name="is_pet" type="radio"
                                        formControlName="is_pet" value=0>
                                    <label for="is_pet_no" class="checkbox-custom-label">No</label>
                                </li>
                            </ul>
                            <ngb-alert [dismissible]="false" [type]="'danger'"
                                *ngIf="onlineApplicationForm1.get('is_pet')?.dirty && onlineApplicationForm1.get('is_pet')?.invalid"
                                class="text-left">
                                <div *ngIf="onlineApplicationForm1.get('is_pet')?.errors?.required">Pet information is required.
                                </div>
                            </ngb-alert>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="form-group">
                            <label>Type/Breed of Pet</label>
                            <input type="text" class="form-control simple" formControlName="type_of_pet">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="form-group">
                            <label>If yes, your pet's description?</label>
                            <input type="text" class="form-control simple" formControlName="pet_description">
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="form-group">
                            <label>When would you like to move?</label>
                            <input type="text" class="form-control simple" formControlName="move_on">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="form-group">
                            <label>Previous Address 1</label>
                            <input type="text" class="form-control simple" formControlName="prev_address1">
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="form-group">
                            <label>Previous Address 2</label>
                            <input type="text" class="form-control simple" formControlName="prev_address2">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-3">
                        <div class="form-group">
                            <label>Previous City</label>
                            <input type="text" class="form-control simple" formControlName="prev_city">
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3">
                        <div class="form-group">
                            <label>Previous State</label>
                            <input type="text" class="form-control simple" formControlName="prev_state">
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3">
                        <div class="form-group">
                            <label>Previous Zip</label>
                            <input type="text" class="form-control simple" formControlName="prev_zip">
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3">
                        <div class="form-group">
                            <label>Previous Country</label>
                            <input type="text" class="form-control simple" formControlName="prev_country">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Additional info/comments</label>
                            <input type="text" class="form-control simple" formControlName="additional_comments">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 text-right">
                        <button type="submit" class="btn btn-theme btn-rounded"><i
                                class="lni lni-arrow-right-circle"></i>Next</button>
                    </div>
                </div>
            </fieldset>
        </form>

        <form class="apply-online" [formGroup]="onlineApplicationForm2" (ngSubmit)="onlineApplication2()">
            <fieldset *ngIf="step===2">
                <div class="row">
                    <div class="col-lg-12">
                        <h2 class="h4 mb-3 theme-cl">About Co-Applicants(if applicable)</h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-3">
                        <div class="form-group">
                            <label>First Name</label>
                            <input type="text" class="form-control simple" formControlName="co_name">
                            <ngb-alert [dismissible]="false" [type]="'danger'"
                                *ngIf="onlineApplicationForm2.get('co_name')?.dirty && onlineApplicationForm2.get('co_name')?.invalid"
                                class="text-left">
                                <div *ngIf="onlineApplicationForm2.get('co_name')?.errors?.required">First Name is
                                    required.
                                </div>
                            </ngb-alert>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3">
                        <div class="form-group">
                            <label>Last Name</label>
                            <input type="text" class="form-control simple" formControlName="co_surname">
                            <ngb-alert [dismissible]="false" [type]="'danger'"
                                *ngIf="onlineApplicationForm2.get('co_surname')?.dirty && onlineApplicationForm2.get('co_surname')?.invalid"
                                class="text-left">
                                <div *ngIf="onlineApplicationForm2.get('co_surname')?.errors?.required">Last Name is
                                    required.
                                </div>
                            </ngb-alert>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="form-group">
                            <label>Email</label>
                            <input type="eamil" class="form-control simple" formControlName="co_username">
                            <ngb-alert [dismissible]="false" [type]="'danger'"
                                *ngIf="onlineApplicationForm2.get('co_username')?.dirty && onlineApplicationForm2.get('co_username')?.invalid"
                                class="text-left">
                                <div *ngIf="onlineApplicationForm2.get('co_username')?.errors?.pattern">Email is
                                    invalid.
                                </div>
                                <div *ngIf="onlineApplicationForm2.get('co_username')?.errors?.required">Email is
                                    required.
                                </div>
                            </ngb-alert>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-3">
                        <div class="form-group">
                            <label>Work Phone</label>
                            <input type="tel" class="form-control simple" mask="0*" maxlength="12"
                                formControlName="co_work_phone">
                            <ngb-alert [dismissible]="false" [type]="'danger'"
                                *ngIf="onlineApplicationForm2.get('co_work_phone')?.dirty && onlineApplicationForm2.get('co_work_phone')?.invalid"
                                class="text-left">
                                <div *ngIf="onlineApplicationForm2.get('co_work_phone')?.errors?.required">Work Phone is
                                    required.
                                </div>
                                <div *ngIf="onlineApplicationForm2.get('co_work_phone')?.errors?.mask">Work Phone is
                                    invalid.
                                </div>
                            </ngb-alert>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3">
                        <div class="form-group">
                            <label>Home Phone</label>
                            <input type="tel" class="form-control simple" mask="0*" maxlength="12"
                                formControlName="co_home_phone">
                            <ngb-alert [dismissible]="false" [type]="'danger'"
                                *ngIf="onlineApplicationForm2.get('home_phone')?.dirty && onlineApplicationForm2.get('home_phone')?.invalid"
                                class="text-left">
                                <div *ngIf="onlineApplicationForm2.get('home_phone')?.errors?.required">Home Phone is
                                    required.
                                </div>
                                <div *ngIf="onlineApplicationForm2.get('home_phone')?.errors?.mask">Home Phone is
                                    invalid.
                                </div>
                            </ngb-alert>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3">
                        <div class="form-group">
                            <label>Cell Phone</label>
                            <input type="tel" class="form-control simple" formControlName="co_cell_phone">
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3">
                        <div class="form-group">
                            <label>Occupation</label>
                            <input type="text" class="form-control simple" formControlName="co_occupation">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-3">
                        <div class="form-group">
                            <label>Company Name</label>
                            <input type="text" class="form-control simple" formControlName="co_company_name">
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3">
                        <div class="form-group">
                            <label>Length of Employment</label>
                            <input type="number" class="form-control simple" formControlName="co_length_of_employment">
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3">
                        <div class="form-group">
                            <label>Monthly net Income</label>
                            <input type="text" class="form-control simple" formControlName="co_monthly_net_income">
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3">
                        <div class="form-group">
                            <label>Other Monthly Income</label>
                            <input type="text" class="form-control simple" formControlName="co_other_monthly_income">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <div class="form-group">
                            <label>Social Security Number</label>
                            <input type="text" class="form-control simple" mask="000-00-0*" maxlength="14"
                                formControlName="co_social_security_number">
                            <ngb-alert [dismissible]="false" [type]="'danger'"
                                *ngIf="onlineApplicationForm2.get('co_social_security_number')?.dirty && onlineApplicationForm2.get('co_social_security_number')?.invalid"
                                class="text-left">
                                <div *ngIf="onlineApplicationForm2.get('co_social_security_number')?.errors?.required">
                                    Social Security Number is required.
                                </div>
                                <div *ngIf="onlineApplicationForm2.get('co_social_security_number')?.errors?.mask">
                                    Social Security Number is invalid.
                                </div>
                            </ngb-alert>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <div class="form-group">
                            <label>Drivers License Number</label>
                            <input type="text" maxlength="16" class="form-control simple"
                                formControlName="co_drivers_license_number">
                            <ngb-alert [dismissible]="false" [type]="'danger'"
                                *ngIf="onlineApplicationForm2.get('co_drivers_license_number')?.dirty && onlineApplicationForm2.get('co_drivers_license_number')?.invalid"
                                class="text-left">
                                <div *ngIf="onlineApplicationForm2.get('co_drivers_license_number')?.errors?.required">
                                    Drivers License Number is required.
                                </div>
                                <!-- <div *ngIf="onlineApplicationForm2.get('co_drivers_license_number')?.errors?.mask">
                                    Drivers License Number is invalid.
                                </div> -->
                            </ngb-alert>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <div class="form-group">
                            <label>Birth Date</label>
                            <input type="text" placeholder="mm/dd/yyyy" class="form-control simple" mask="M0/d0/0000"
                                [leadZeroDateTime]="true" class="form-control simple" formControlName="co_birth_date">
                            <ngb-alert [dismissible]="false" [type]="'danger'"
                                *ngIf="onlineApplicationForm2.get('co_birth_date')?.dirty && onlineApplicationForm2.get('co_birth_date')?.invalid"
                                class="text-left">
                                <div *ngIf="onlineApplicationForm2.get('co_birth_date')?.errors?.required">Birth Date is
                                    required.
                                </div>
                            </ngb-alert>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <div class="form-group">
                            <label>Savings Account Bank</label>
                            <input type="text" class="form-control simple" formControlName="co_savings_account_bank">
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <div class="form-group">
                            <label>Branch</label>
                            <input type="text" class="form-control simple" formControlName="co_saving_branch">
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <div class="form-group">
                            <label>Account Number</label>
                            <input type="text" class="form-control simple" formControlName="co_saving_account_number">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <div class="form-group">
                            <label>Checking Account Bank</label>
                            <input type="text" class="form-control simple" formControlName="co_checking_account_bank">
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <div class="form-group">
                            <label>Branch</label>
                            <input type="text" class="form-control simple" formControlName="co_checking_branch">
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <div class="form-group">
                            <label>Account Number</label>
                            <input type="text" class="form-control simple" formControlName="co_checking_account_number">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                            <label>Current Address1</label>
                            <input type="text" class="form-control simple" formControlName="co_current_address1">
                            <ngb-alert [dismissible]="false" [type]="'danger'"
                                *ngIf="onlineApplicationForm2.get('co_current_address1')?.dirty && onlineApplicationForm2.get('co_current_address1')?.invalid"
                                class="text-left">
                                <div *ngIf="onlineApplicationForm2.get('co_current_address1')?.errors?.required">Current
                                    Address1 is required.
                                </div>
                            </ngb-alert>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="form-group">
                            <label>Current Address2</label>
                            <input type="text" class="form-control simple" formControlName="co_current_address2">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-3">
                        <div class="form-group">
                            <label>City</label>
                            <input type="text" class="form-control simple" formControlName="co_city">
                            <ngb-alert [dismissible]="false" [type]="'danger'"
                                *ngIf="onlineApplicationForm2.get('co_city')?.dirty && onlineApplicationForm2.get('co_city')?.invalid"
                                class="text-left">
                                <div *ngIf="onlineApplicationForm2.get('co_city')?.errors?.required">City is required.
                                </div>
                            </ngb-alert>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3">
                        <div class="form-group">
                            <label>State</label>
                            <input type="text" class="form-control simple" formControlName="co_state">
                            <ngb-alert [dismissible]="false" [type]="'danger'"
                                *ngIf="onlineApplicationForm2.get('co_state')?.dirty && onlineApplicationForm2.get('co_state')?.invalid"
                                class="text-left">
                                <div *ngIf="onlineApplicationForm2.get('co_state')?.errors?.required">State is required.
                                </div>
                            </ngb-alert>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3">
                        <div class="form-group">
                            <label>Zip Code</label>
                            <input type="text" mask="0*" maxlength="8" class="form-control simple"
                                formControlName="co_zipcode">
                            <ngb-alert [dismissible]="false" [type]="'danger'"
                                *ngIf="onlineApplicationForm2.get('co_zipcode')?.dirty && onlineApplicationForm2.get('co_zipcode')?.invalid"
                                class="text-left">
                                <div *ngIf="onlineApplicationForm2.get('co_zipcode')?.errors?.required">Zip Code is
                                    required.
                                </div>
                                <div *ngIf="onlineApplicationForm2.get('co_zipcode')?.errors?.mask">Zip Code is invalid.
                                </div>
                            </ngb-alert>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3">
                        <div class="form-group">
                            <label>Country</label>
                            <input type="text" class="form-control simple" formControlName="co_country">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="form-group">
                            <label>How Long at This Address</label>
                            <input type="text" class="form-control simple" formControlName="co_howlong_at_this_address">
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3">
                        <div class="form-group">
                            <label>Rent</label>
                            <input type="text" class="form-control simple" formControlName="co_rent">
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3">
                        <div class="form-group">
                            <label>Reason For Moving</label>
                            <input type="text" class="form-control simple" formControlName="co_reason_for_moving">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="form-group">
                            <label>Owner / Landlord</label>
                            <input type="text" class="form-control simple" formControlName="co_owner">
                            <ngb-alert [dismissible]="false" [type]="'danger'"
                                *ngIf="onlineApplicationForm2.get('co_owner')?.dirty && onlineApplicationForm2.get('co_owner')?.invalid"
                                class="text-left">
                                <div *ngIf="onlineApplicationForm2.get('co_owner')?.errors?.required">Owner / Landlord
                                    is required.
                                </div>
                            </ngb-alert>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="form-group">
                            <label>Phone</label>
                            <input type="tel" class="form-control simple" mask="000000000*" maxlength="13" formControlName="co_phone">
                            <ngb-alert [dismissible]="false" [type]="'danger'"
                                *ngIf="onlineApplicationForm2.get('co_phone')?.dirty && onlineApplicationForm2.get('co_phone')?.invalid"
                                class="text-left">
                                <div *ngIf="onlineApplicationForm2.get('co_phone')?.errors?.required">Phone is required.
                                </div>
                                <div *ngIf="onlineApplicationForm2.get('co_phone')?.errors?.mask">Phone is invalid.
                                </div>
                            </ngb-alert>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-2 col-md-2 col-sm-6">
                        <div class="form-group">
                            <label>Emergency Contact Name</label>
                            <input type="text" class="form-control simple" formControlName="co_emergency_contact_name">
                        </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-6">
                        <div class="form-group">
                            <label>Emergency Contact Phone</label>
                            <input type="tel" class="form-control simple" mask="0*" maxlength="13" formControlName="co_emergency_contact_phone">
                        </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-6">
                        <div class="form-group">
                            <p>Do You Have Any Pets</p>
                            <ul class="no-ul-list">
                                <li>
                                    <input id="co_is_pet_yes" class="checkbox-custom" name="co_is_pet" type="radio"
                                        formControlName="co_is_pet" value=1>
                                    <label for="co_is_pet_yes" class="checkbox-custom-label">Yes</label>
                                </li>
                                <li>
                                    <input id="co_is_pet_no" class="checkbox-custom" name="co_is_pet" type="radio"
                                        formControlName="co_is_pet" value=0>
                                    <label for="co_is_pet_no" class="checkbox-custom-label">No</label>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="form-group">
                            <label>Type/Breed of Pet</label>
                            <input type="text" class="form-control simple" formControlName="co_type_of_pet">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="form-group">
                            <label>If yes, your pet's description?</label>
                            <input type="text" class="form-control simple" formControlName="co_pet_description">
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="form-group">
                            <label>When would you like to move?</label>
                            <input type="text" class="form-control simple" formControlName="co_move_on">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="form-group">
                            <label>Previous Address 1</label>
                            <input type="text" class="form-control simple" formControlName="co_prev_address1">
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6">
                        <div class="form-group">
                            <label>Previous Address 2</label>
                            <input type="text" class="form-control simple" formControlName="co_prev_address2">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-3">
                        <div class="form-group">
                            <label>Previous City</label>
                            <input type="text" class="form-control simple" formControlName="co_prev_city">
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3">
                        <div class="form-group">
                            <label>Previous State</label>
                            <input type="text" class="form-control simple" formControlName="co_prev_state">
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3">
                        <div class="form-group">
                            <label>Previous Zip</label>
                            <input type="text" class="form-control simple" formControlName="co_prev_zip">
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3">
                        <div class="form-group">
                            <label>Previous Country</label>
                            <input type="text" class="form-control simple" formControlName="co_prev_country">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>Additional info/comments</label>
                            <input type="text" class="form-control simple" formControlName="co_additional_comments">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-6 text-left">
                        <button type="button" class="btn btn-theme btn-rounded" (click)="previous()"><i
                                class="lni lni-arrow-left-circle"></i>Previous</button>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6 text-right">
                        <button type="submit" class="btn btn-theme btn-rounded"><i
                                class="lni lni-arrow-right-circle"></i>Next</button>
                    </div>
                </div>
            </fieldset>
        </form>

        <form class="apply-online" [formGroup]="onlineApplicationForm3" (ngSubmit)="onlineApplication3()">
            <fieldset *ngIf="step===3">
                <div class="row">
                    <div class="col-lg-12">
                        <h2 class="h4 mb-3 theme-cl">About others that will be living at new address</h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <label>Total people that will be living at property :</label>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <div class="form-group">
                            <label>Total Adults<span style="color: red;"> *</span></label>
                            <input type="text" class="form-control simple" formControlName="total_adults" mask="0*">
                            <ngb-alert [dismissible]="false" [type]="'danger'"
                                *ngIf="onlineApplicationForm3.get('total_adults')?.dirty && onlineApplicationForm3.get('total_adults')?.invalid"
                                class="text-left">
                                <div *ngIf="onlineApplicationForm3.get('total_adults')?.errors?.required">Total Adults
                                    is required.
                                </div>
                                <div *ngIf="onlineApplicationForm3.get('total_adults')?.errors?.mask">Total Adults is
                                    invalid.
                                </div>
                            </ngb-alert>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <div class="form-group">
                            <label>Total Children<span style="color: red;"> *</span></label>
                            <input type="text" class="form-control simple" formControlName="total_children" mask="0*">
                            <ngb-alert [dismissible]="false" [type]="'danger'"
                                *ngIf="onlineApplicationForm3.get('total_children')?.dirty && onlineApplicationForm3.get('total_children')?.invalid"
                                class="text-left">
                                <div *ngIf="onlineApplicationForm3.get('total_children')?.errors?.required">Total
                                    Children is required.
                                </div>
                                <div *ngIf="onlineApplicationForm3.get('total_children')?.errors?.mask">Total Children
                                    is invalid
                                </div>
                            </ngb-alert>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <div class="form-group">
                            <label>Person 1 Full Name</label>
                            <input type="text" class="form-control simple" formControlName="p1_full_name">
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <div class="form-group">
                            <label>Age</label>
                            <input type="text" class="form-control simple" formControlName="p1_age">
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <div class="form-group">
                            <label>Relationship</label>
                            <input type="text" class="form-control simple" formControlName="p1_relationship">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <div class="form-group">
                            <label>Person 2 Full Name</label>
                            <input type="text" class="form-control simple" formControlName="p2_full_name">
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <div class="form-group">
                            <label>Age</label>
                            <input type="text" class="form-control simple" formControlName="p2_age">
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <div class="form-group">
                            <label>Relationship</label>
                            <input type="text" class="form-control simple" formControlName="p2_relationship">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <div class="form-group">
                            <label>Person 3 Full Name</label>
                            <input type="text" class="form-control simple" formControlName="p3_full_name">
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <div class="form-group">
                            <label>Age</label>
                            <input type="text" class="form-control simple" formControlName="p3_age">
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <div class="form-group">
                            <label>Relationship</label>
                            <input type="text" class="form-control simple" formControlName="p3_relationship">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <div class="form-group">
                            <label>Person 4 Full Name</label>
                            <input type="text" class="form-control simple" formControlName="p4_full_name">
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <div class="form-group">
                            <label>Age</label>
                            <input type="text" class="form-control simple" formControlName="p4_age">
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <div class="form-group">
                            <label>Relationship</label>
                            <input type="text" class="form-control simple" formControlName="p4_relationship">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-6 text-left">
                        <button type="button" class="btn btn-theme btn-rounded" (click)="previous()"><i
                                class="lni lni-arrow-left-circle"></i>Previous</button>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6 text-right">
                        <button type="submit" class="btn btn-theme btn-rounded"><i
                                class="lni lni-arrow-right-circle"></i>Next</button>
                    </div>
                </div>
            </fieldset>
        </form>

        <form class="apply-online" [formGroup]="onlineApplicationForm4" (ngSubmit)="onlineApplication4()">
            <fieldset *ngIf="step===4">
                <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-3">
                        <h3>Documents Upload <i class="lni lni-question-circle" [ngbPopover]="popoverContent"
                                triggers="hover"></i></h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-6 text-left">
                        <input #documents type="file" class="btn" multiple="true" (change)="onFileSelected($event)"
                            accept="application/pdf,application/x-pdf,application/msword,image/jpeg,image/png,image/jpg,text/html,text/plain"
                            formControlName="files_upload" style="padding-left:0;">
                        <ngb-alert [dismissible]="false" [type]="'danger'"
                            *ngIf="onlineApplicationForm4.get('files_upload')?.dirty && onlineApplicationForm4.get('files_upload')?.invalid"
                            class="text-left">
                            <div *ngIf="onlineApplicationForm4.get('files_upload')?.errors?.required">Please Select File
                            </div>
                            <div *ngIf="onlineApplicationForm4.get('files_upload')?.errors?.maxLength">Please Select
                                File
                            </div>
                        </ngb-alert>
                    </div>
                </div>
                <div *ngIf="progressInfos" class="row">
                    <div class="col-12 select-file-input">
                        <div *ngFor="let progressInfo of progressInfos; let index = index" class="mb-2">
                            <div class="row" style="align-self:center;align-items: center;">
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <span class="d-flex align-items-center form-control">{{
                                        progressInfo.filename}}</span>
                                </div>
                                <div class="col-lg-5 col-md-5 col-sm-5 col-11">
                                    <ng-select [id]="index" class="form-control" [formControlName]="index"
                                        (change)="doc_type($event,index)" placeholder="Select Document Type"
                                        [(ngModel)]="progressInfo.doc_type" [items]="doc_types" bindLabel="title"
                                        bindValue="id">
                                    </ng-select>
                                    <ngb-alert [dismissible]="false" [type]="'danger'"
                                        *ngIf="onlineApplicationForm4.get([index])?.dirty && onlineApplicationForm4.get([index])?.invalid"
                                        class="text-left">
                                        <div *ngIf="onlineApplicationForm4.get([index])?.errors?.required">Please Select
                                            Document Type
                                        </div>
                                    </ngb-alert>
                                </div>
                                <div class="col-1">
                                    <button (click)="removeImage(index)" class="close-file">x</button>
                                    <div class="progress" style="display: none;">
                                        <!-- <div
                                        class="progress-bar progress-bar-info progress-bar-striped"
                                        role="progressbar"
                                        attr.aria-valuenow="{{ progressInfo.value }}"
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                        [ngStyle]="{ width: progressInfo.value + '%' }"
                                    >
                                        {{ progressInfo.value }}%
                                    </div> -->
                                    </div>
                                </div>
                            </div>




                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="form-group">
                            <h4>Terms</h4>
                            <ul class="no-ul-list">
                                <li>
                                    <input id="yes" class="checkbox-custom" type="checkbox" formControlName="terms">
                                    <label for="yes" class="checkbox-custom-label" style="display: -webkit-inline-box;">
                                        <p class="add-pro-adver-p3">I have read and understand the residential selection
                                            criteria, application process, and agency disclosure.<br>I understand that
                                            all deposits and fees are non-refundable. I declare that the statements
                                            above are true and correct. I authorize North Bloomfield Properties (NBP) to
                                            obtain information on my rental / credit / criminal / employment / source of
                                            income history by contacting any references necessary to evaluate renting
                                            risks.I hereby release all references to give NBP all requested information.
                                        </p>
                                    </label>
                                    <ngb-alert [dismissible]="false" [type]="'danger'"
                                        *ngIf="onlineApplicationForm4.get('terms')?.dirty && onlineApplicationForm4.get('terms')?.invalid"
                                        class="text-left">
                                        <div *ngIf="onlineApplicationForm4.get('terms')?.errors?.required">Please Accept
                                            Tearms
                                        </div>
                                    </ngb-alert>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-3">
                        <div class="form-group">
                            <label for="submit_date">Submit Date </label>
                            <input type="date" id="submit_date" class="form-control simple"
                                formControlName="submit_date">
                            <ngb-alert [dismissible]="false" [type]="'danger'"
                                *ngIf="onlineApplicationForm4.get('submit_date')?.dirty && onlineApplicationForm4.get('submit_date')?.invalid"
                                class="text-left">
                                <div *ngIf="onlineApplicationForm4.get('submit_date')?.errors?.required">Submit Date is
                                    required
                                </div>
                            </ngb-alert>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-6 text-left">
                        <button type="button" class="btn btn-theme btn-rounded" (click)="previous()"><i
                                class="lni lni-arrow-left-circle"></i>Previous</button>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6 text-right">
                        <button type="submit" class="btn btn-theme btn-rounded"><i class="lni lni-clipboard"></i>Submit
                            Application</button>
                    </div>
                </div>
            </fieldset>
        </form>
    </div>
</section>

<ng-template #dangerTpl>
    <svg xmlns="http://www.w3.org/2000/svg" fill="#fff" width="24" height="24" viewBox="0 0 24 24">
        <path
            d="M10.872 6.831l1.695 3.904 3.654-1.561-1.79 3.426 3.333.954-3.417 1.338 2.231 4.196-4.773-2.582-2.869 2.287.413-3.004-3.792-.726 2.93-1.74-1.885-2.512 3.427.646.843-4.626zm-.786-6.831l-1.665 9.119-6.512-1.228 3.639 4.851-5.548 3.294 7.108 1.361-.834 6.076 5.742-4.577 9.438 5.104-4.288-8.064 6.834-2.677-6.661-1.907 3.25-6.22-6.98 2.982-3.523-8.114z" />
    </svg>
    Operation Failed!
</ng-template>

<ng-template #popoverContent>
    <div class="list_detail" style="text-align:justify; margin:5px 15px 10px 5px;">
        <ol style="color: #3F3E3E; line-height: 15px;">
            <li style="margin-bottom:5px;">A completed NBP application. Hard copy or online application. <a
                    href="www.northbloomfield.com">www.northbloomfield.com.</a><br />Please make sure to include date of
                birth, social security number, current landlord's name and telephone number. In addition, include
                information for any other adults that will be living in the household (names, ages, and relationship to
                applicant).</li>

            <li style="margin-bottom:5px;">Copy of identification. A current Driver's license or state ID.</li>

            <li>Proof of current income. <br />You must provide any or all of the following that apply: a recent paystub, tax
                document, offer letter for new employment with start date, child support, spousal
                support, social security documents.</li>

            <li>Most recent bank statement.</li>

            <li style="margin-bottom:5px;">Paid application fee of $50. If there are any issues paying online, please call our
                office @ 248-366-8484 and we can accept payment with credit or debit card.</li>

            <li style="margin-bottom:5px;">All five items will need to be done and or submitted before the application dept
                will process the application. If you do not provide all of the information your
                application will not be processed.</li>

            <li style="margin-bottom:5px;"><span style="color:#890000;">Please note:</span> We will be pulling the
                clients credit report. We will not accept outside credit reports. No exceptions.</li>
        </ol>
    </div>
</ng-template>